import React, { useMemo } from 'react';
import { DimensionValue, View } from 'react-native';

import { BrandColor } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import { BodyText } from '../../../ui';
import { BasicStarFilledIcon } from '../../../ui/Icons';

const THREE_DIGIT_WIDTH = 39;

type ReviewStarSummaryItemProps = {
  itemStars: number;
  itemRatings: number;
  totalRatings: number;
};

export const ReviewStarSummaryItem: React.FCWithChildren<ReviewStarSummaryItemProps> = ({
  itemStars,
  itemRatings,
  totalRatings,
}) => {
  /**
   * The percentage of highlight that the given star rating should show
   */
  const percentageWidth = useMemo<DimensionValue>(() => {
    const starPercentage = (itemRatings / totalRatings) * 100;

    if (starPercentage && starPercentage < 2) {
      return '2%';
    }
    if (Number.isNaN(starPercentage)) {
      return '0%';
    }
    return `${Math.round(starPercentage)}%`;
  }, [
    itemRatings,
    totalRatings,
  ]);

  /**
   * The percentage of reviews that the given star rating is
   */
  const percentageText = useMemo(() => {
    const starRatio = (itemRatings / totalRatings) || 0;
    const starPercentage = starRatio * 100;

    if (starPercentage && starPercentage < 0.5) {
      return '<1%';
    }
    return `${Math.round(starPercentage)}%`;
  }, [
    itemRatings,
    totalRatings,
  ]);

  return (
    <Inline space={4} alignItems="center">
      <Box paddingRight={8}>
        <BodyText appearance="small">
          {itemStars}
        </BodyText>
      </Box>
      <BasicStarFilledIcon color={BrandColor.Silver} width={10} height={10} />
      <View
        style={{
          backgroundColor: BrandColor.LightGrey,
          minWidth: 162,
          height: 2,
        }}
      >
        <View
          style={{
            backgroundColor: BrandColor.Yellow,
            width: percentageWidth,
            height: 2,
          }}
        />
      </View>
      <Box paddingLeft={8} minWidth={THREE_DIGIT_WIDTH}>
        <BodyText appearance="small">
          {percentageText}
        </BodyText>
      </Box>
    </Inline>
  );
};
